import React, { useContext, useEffect, useState } from "react";
import { Box, Text, ThemeContext } from "grommet";
import useSWR from "swr";
import { useRouter } from "next/router";
import { handleErrors } from "../../../utils/errors";
import { DialogContext } from "../../DialogProvider";
import { NotificationsContext } from "../../NotificationsProvider";
import ConnectionCard from "./ConnectionCard";
import LinkQuickbooks from "../../LinkQuickbooks";
import { unlinkQuickbooks } from "../../../utils/connections";
import { formatDate, formatTime } from "../../../utils/dates";
import {
    faCancel as IconCancel,
    faCircleCheck as IconCircleCheck
} from '@fortawesome/pro-light-svg-icons';
import FontAwesomeIcon from "../../FontAwesomeIcon";

const QuickbooksConnectionComponent = ({
    onConnectionChange,
    user,
    onLinked
}) => {
    const [isConnected, setIsConnected] = useState();
    const [connectedTime, setConnectedTime] = useState();
    const [companyName, setCompanyName] = useState();
    const [isActive, setIsActive] = useState(true);
    const notificationCtx = useContext(NotificationsContext);
    const router = useRouter();

    const fetcher = (url) =>
        fetch(url).then(handleErrors).catch(notificationCtx.showNotification);

    const {data} = useSWR("/api/settings/quickbooks", fetcher, {
        revalidateOnFocus: false
    });

    useEffect(() => {
        if(!data) return;
        setConnectedTime(data.created_at);
        setIsConnected(!!data.created_at || false);
        setCompanyName(data?.company_name)
        setIsActive(data?.connected)
        onConnectionChange && onConnectionChange(connected);
    }, [data]);


    const renderQuickbooksOauth = () => {
        return (
            <LinkQuickbooks
                userId={user?.id}
                onLinked={() => {
                    onLinked && onLinked();
                }}
                ctaColor="status-ok"
            />
        )
    }

    return (
        <ThemeContext.Consumer>
            {(theme) => (
                <DialogContext.Consumer>
                    { ({ showDialog }) => (
                        <ConnectionCard
                            cta={!isConnected && renderQuickbooksOauth()}
                            details={isConnected ? [
                                <Box key="connected-status" direction="row" gap="xsmall" fill="horizontal" align="center" justify="start" pad={{vertical: 'xsmall'}}>
                                    <FontAwesomeIcon SelectedIcon={isActive ? IconCircleCheck : IconCancel} color={isActive ? 'green-strong' : 'status-critical-2'} size="small" />
                                    <Text textAlign="center" color={isActive ? 'green-strong' : 'status-critical-2'}>{isActive ? 'Connected' : 'Disconnected'}</Text>
                                </Box>,
                                companyName,
                                `Connected on ${formatDate(connectedTime)} at ${formatTime(connectedTime)}`
                            ].filter(Boolean) : [
                                "Sync your invoicing data automatically. Save time and eliminate manual entry."
                            ]}
                            logoSrc={`/brand_logos/quickbooks_symbol${theme.dark ? '_white' : ''}.svg`}
                            connectionName="Intuit QuickBooks"
                            isLoaded={!!data}
                            menuItems={isConnected ? [
                                {
                                    label: (<Text>Settings</Text>),
                                    onClick: () => {router.push("/settings/connections/quickbooks")},
                                    event: {section: `quickbooks_connection_card`, element: 'go_to_quickbooks_setting'}
                                },
                                {
                                    label: (<Text color='status-critical'>Unlink QuickBooks</Text>),
                                    onClick: () => {
                                        showDialog({
                                            title: 'Unlink QuickBooks',
                                            message: 'Are you sure you would like to unlink your QuickBooks account?',
                                            callback: () => unlinkQuickbooks(
                                                notificationCtx.showNotification,
                                                router.reload
                                            ),
                                            ctaType: 'error'
                                        });
                                    },
                                    event: {section: `quickbooks_connection_card`, element: 'unlink_quickbooks'}
                                },
                            ] : null} />
                    )}
                </DialogContext.Consumer>
            )}
        </ThemeContext.Consumer>
    );
};

export default QuickbooksConnectionComponent;
